<template>
  <div
    class="as-schematic-item__body"
    :class="{
      'as-active': match?.match_ids && match?.match_ids.includes(matchID),
    }"
  >
    <div
      class="as-schematic-player as-schematic-player__home"
      v-if="match.home_team_id && match.home_team"
    >
      <div class="as-schematic-info">
        <div class="as-d-inline-flex">
          <img
            v-if="match?.home_team?.sub_ids?.length"
            v-for="(sub, index) in match?.home_team?.sub_ids"
            class="as-schematic-info__img"
            :class="`as-logo-${index}`"
            :src="getImgUrlBySport('team', sub)"
          />
          <img
            v-else
            class="as-schematic-info__img"
            :src="getImgUrlBySport('team', match.home_team_id)"
          />
        </div>

        <div
          class="as-schematic-info__name"
          :class="{ isNull: !match.home_team_id }"
        >
          {{ !match.home_team_id ? "-" : match?.home_team?.name }}
        </div>
        <div
          class="as-schematic-info__is-champion"
          v-if="isShowTheChampion && getScoresBracket('home', match) > getScoresBracket('away', match)"
        >
          <IconTheChampion />
        </div>
      </div>
      <div
        class="as-schematic-score"
        :class="{
          'as-active':
            match.home_team_id && match.away_team_id
              ? setActiveScoreBracketItem(getScoresBracket('home', match), getScoresBracket('away', match))
              : '',
          isNull: !match.home_team_id,
        }"
      >
        <span>{{ !match.home_team_id ? "-" : getScoresBracket('home', match) }}</span>
      </div>
    </div>
    <div v-else class="as-schematic-player as-schematic-player__home">
      <BracketItemMatchNull />
    </div>
    <div
      class="as-schematic-player as-schematic-player__away"
      v-if="match.away_team_id && match.away_team"
    >
      <div class="as-schematic-info">
        <div class="as-d-inline-flex">
          <img
            v-if="match?.away_team?.sub_ids?.length"
            v-for="(sub, index) in match?.away_team?.sub_ids"
            class="as-schematic-info__img"
            :class="`as-logo-${index}`"
            :src="getImgUrlBySport('team', sub)"
          />
          <img
            v-else
            class="as-schematic-info__img"
            :src="
              getImgUrlBySport('team', match.away_team_id)
            "
          />
        </div>
        <div
          class="as-schematic-info__name"
          :class="{ isNull: !match.away_team_id }"
        >
          {{ !match.away_team_id ? "-" : match?.away_team?.name }}
        </div>
        <div
          class="as-schematic-info__is-champion"
          v-if="isShowTheChampion && getScoresBracket('home', match) < getScoresBracket('away', match)"
        >
          <IconTheChampion />
        </div>
      </div>
      <div
        class="as-schematic-score"
        :class="{
          'as-active':
            match.home_team_id && match.away_team_id
              ? setActiveScoreBracketItem(
                  getScoresBracket('home', match),
                  getScoresBracket('away', match),
                  'away'
                )
              : '',
          isNull: !match.away_team_id,
        }"
      >
        <span>{{ !match.away_team_id ? "-" : getScoresBracket('away', match) }}</span>
      </div>
    </div>

    <div v-else class="as-schematic-player as-schematic-player__away">
      <BracketItemMatchNull />
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { ITournamentMatchUp } from "~src/interfaces/tennis";
import { setActiveScoreBracketItem } from "~src/helpers/tennis";
import MatchTennisEnum from "~src/enums/tennis/MatchEnum";
import BracketItemMatchNull from "./BracketItemMatchNull.vue";
import IconTheChampion from "~src/components/icons/IconTheChampion.vue";
import MatchEnum from "~src/enums/volleyball/MatchEnum";

import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  matchID: string;
  match: ITournamentMatchUp;
  isNull: boolean;
  roundKey?: string;
  roundIndex?: number;
  isShowTheChampion: boolean;
}

withDefaults(defineProps<IProps>(), {
  isNull: false,
  isShowTheChampion: false,
});
const sportType = computed(() => commonStore.getSportType);
const getScoresBracket = (mode: string, match: any) => {
  let playing = MatchEnum.LIST_STATUS_PLAYING;
  let score = match?.home_score ?? 0;
  if(mode === 'away'){
    score = match?.away_score ?? 0;
  }
  if(sportType.value === 'tennis'){
    playing = MatchTennisEnum.LIST_STATUS_PLAYING;
  }
  const i_match = match?.i_match ?? {};
  if(i_match && i_match?.id){
    // if(playing.includes(i_match?.status_id)){
      const scores = i_match?.scores ?? [];
      if(scores && scores['ft']){
        score = scores['ft'][0];
        if (mode === "away") {
          score = scores['ft'][1];
        }
      }
      
    // }
  }
  
  return score;
}
</script>

<script lang="ts">
export default {};
</script>
